import { Patient, EventCategory, Event } from "./model";

export type IndexedEntities<T> = { [key: number]: T };
const indexArray = <T extends { id: number }>(arr: T[]) => {
  return arr.reduce((obj, item) => {
    obj[item.id] = item;
    return obj;
  }, {} as IndexedEntities<T>);
};

export const images = [
  "https://cdn.vuetifyjs.com/images/lists/1.jpg",
  "https://cdn.vuetifyjs.com/images/lists/2.jpg",
  "https://cdn.vuetifyjs.com/images/lists/3.jpg",
  "https://cdn.vuetifyjs.com/images/lists/4.jpg",
  "https://cdn.vuetifyjs.com/images/lists/5.jpg",
  "http://icons.iconarchive.com/icons/hopstarter/face-avatars/256/Female-Face-FA-3-icon.png",
  "http://icons.iconarchive.com/icons/hopstarter/face-avatars/256/Female-Face-FC-5-icon.png",
  "http://icons.iconarchive.com/icons/hopstarter/face-avatars/256/Male-Face-K3-icon.png",
  "https://image.flaticon.com/icons/png/128/95/95424.png",
  "https://www.wikihow.com/images_en/thumb/1/18/Change-a-Disposable-Adult-Diaper-Step-3-Version-2.jpg/v4-728px-Change-a-Disposable-Adult-Diaper-Step-3-Version-2.jpg",
  "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTsZvsvtEG7LgRzuPcyqou4Cyoe1Ow0k73mJk4CdjG4pVgFBOzy&s",
  "https://imgix.bustle.com/uploads/image/2017/12/22/81543f53-e8a0-4c54-a1d0-15afdf7a43b7-fotolia_89707367_subscription_monthly_m-1.jpg?w=960&h=540&fit=crop&crop=faces&auto=format&q=70",
  "https://cdn4.iconfinder.com/data/icons/emojis-flat-pixel-perfect/64/emoji-41-512.png",
  "https://us.123rf.com/450wm/sodis/sodis1709/sodis170900027/85130548-man-is-sleeping-in-bed-flat-design-vector-illustration-.jpg?ver=6"
];

export const imageURL = (id: number) => images[id];
export const eventCategory = (categoryId: number) =>
  eventCategories[categoryId];
export const patientEvents = (patientId: number) =>
  Object.values(patientsEvents[patientId] || {});

let patientId = 0;
export const patients: IndexedEntities<Patient> = indexArray([
  {
    id: ++patientId,
    name: "Jason Oner",
    pictureId: 0,
    summary: "Lorem ipsum dolor sit amet consectetur adipisicing elit."
  },
  {
    id: ++patientId,
    name: "Travis Howard",
    pictureId: 1,
    summary: "Lorem ipsum dolor sit amet consectetur adipisicing elit."
  },
  {
    id: ++patientId,
    name: "Ali Connors",
    pictureId: 2,
    summary: "Lorem ipsum dolor sit amet consectetur adipisicing elit."
  },
  {
    id: ++patientId,
    name: "Cindy Baker",
    pictureId: 3,
    summary: "Lorem ipsum dolor sit amet consectetur adipisicing elit."
  },
  {
    id: ++patientId,
    name: "Dona Fulana",
    pictureId: 4,
    summary: "Voluptate cillum fugiat ad non reprehenderit."
  },
  {
    id: ++patientId,
    name: "Sicrana de Crapio",
    pictureId: 5,
    summary: "Lorem ipsum dolor sit amet consectetur adipisicing elit."
  },
  {
    id: ++patientId,
    name: "Lina Stalone",
    pictureId: 6,
    summary: "Lorem ipsum dolor sit amet consectetur adipisicing elit."
  },
  {
    id: ++patientId,
    name: "Razor Thunder",
    pictureId: 7,
    summary: "Lorem ipsum dolor sit amet consectetur adipisicing elit."
  }
]);

let eventCategoryId = 0;
export const eventCategories: IndexedEntities<EventCategory> = indexArray<
  EventCategory
>([
  {
    id: ++eventCategoryId,
    infinitiveText: "Trocar fralda",
    substantiveText: "Troca de fralda",
    name: "troca-de-fralda",
    iconId: 8,
    pictureId: 9
  },
  {
    id: ++eventCategoryId,
    infinitiveText: "Medir temperatura corporal",
    substantiveText: "Medição de temperatura corporal",
    name: "medir-temperatura",
    iconId: 10,
    pictureId: 11
  },
  {
    id: ++eventCategoryId,
    infinitiveText: "Dormir",
    substantiveText: "Sono",
    name: "dormir",
    iconId: 12,
    pictureId: 13
  }
]);

let eventId = 0;
export const patientsEvents: { [key: number]: IndexedEntities<Event> } = {
  1: indexArray<Event>([
    {
      id: ++eventId,
      categoryId: 1,
      patientId: 1,
      startDate: new Date(Date.now() - 3 * 60 * 60 * 1000)
    },
    {
      id: ++eventId,
      categoryId: 2,
      patientId: 1,
      startDate: new Date(Date.now() - 2.5 * 60 * 60 * 1000),
      valueJson: JSON.stringify(37.2)
    },
    {
      id: ++eventId,
      categoryId: 3,
      patientId: 1,
      startDate: new Date(Date.now() - 2 * 60 * 60 * 1000),
      valueJson: JSON.stringify("Agitado")
    },
    {
      id: ++eventId,
      categoryId: 1,
      patientId: 1,
      startDate: new Date(Date.now() + 1 * 60 * 60 * 1000)
    },
    {
      id: ++eventId,
      categoryId: 2,
      patientId: 1,
      startDate: new Date(Date.now() - 2.5 * 60 * 60 * 1000),
      valueJson: JSON.stringify(37.2)
    },
    {
      id: ++eventId,
      categoryId: 3,
      patientId: 1,
      startDate: new Date(Date.now() - 2 * 60 * 60 * 1000),
      valueJson: JSON.stringify("Agitado")
    },
    {
      id: ++eventId,
      categoryId: 2,
      patientId: 1,
      startDate: new Date(Date.now() - 2.5 * 60 * 60 * 1000),
      valueJson: JSON.stringify(37.2)
    },
    {
      id: ++eventId,
      categoryId: 3,
      patientId: 1,
      startDate: new Date(Date.now() - 2 * 60 * 60 * 1000),
      valueJson: JSON.stringify("Agitado")
    }
  ])
};
